import { render, staticRenderFns } from "./IframeMap.vue?vue&type=template&id=36719266&scoped=true&"
import script from "./IframeMap.vue?vue&type=script&lang=js&"
export * from "./IframeMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36719266",
  null
  
)

export default component.exports